export default "__VITE_PUBLIC_ASSET__312621f2__"